export default [{
    meta: {
        requiresAuth: true
    },
    name: 'hotelCNList',
    path: '/mall/hotelCN/hotelList',
    component: resolve => require(['./hotelList.vue'], resolve)
},{
    meta: {
        requiresAuth: true
    },
    name: 'HotelReserve',
    path: '/mall/hotelCN/HotelReserve',
    component: resolve => require(['./HotelReserve.vue'], resolve)
}]


// WEBPACK FOOTER //
// ./src/views/mall/hotelCN/router.js